/*
  This is the exception wrapper for steps
 */

import React from 'react'
import PatternStep from "./steps/patterns/PatternStep";

const PatternStepByStep = (props) => {

    const displayPatternSteps = () => {
                return <PatternStep currentValues={props.currentValues}/>

    }

    return (
        <div>
            { displayPatternSteps() }
        </div>
    )

}

export default PatternStepByStep;
